import { Route, Routes } from 'react-router-dom';
import { TransitionProvider } from './shared/hooks/useCinematicTransition';
import { Landing } from './features/landing/routes/Landing';
import { Arena } from './features/arena/routes/Arena';
import { Watch } from './features/arena/routes/Watch';
import { WatchTopic } from './features/arena/routes/WatchTopic';
import { WatchDebate } from './features/arena/routes/WatchDebate';
import { Spar } from './features/arena/routes/Spar';
import { SparChat } from './features/arena/routes/SparChat';
import { Worldview } from './features/worldview/routes/Worldview';
import { Chat } from './features/worldview/routes/Chat';

export default function App() {
  return (
    <TransitionProvider>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/arena" element={<Arena />} />
        <Route path="/arena/watch" element={<Watch />} />
        <Route path="/arena/watch/topic" element={<WatchTopic />} />
        <Route path="/arena/watch/debate" element={<WatchDebate />} />
        <Route path="/arena/spar" element={<Spar />} />
        <Route path="/arena/spar/:id" element={<SparChat />} />
        <Route path="/worldview" element={<Worldview />} />
        <Route path="/worldview/chat/:id" element={<Chat />} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </TransitionProvider>
  );
}
